import { Box, Button, Typography, styled } from '@mui/material';

const selectedContainerStyles = {
	borderWidth: '1px',
	borderStyle: 'solid',
	borderColor: '#FFFFFF59',
	backgroundColor: '#FFFFFF1A',
};

export const PaymentContainer = styled(Box)(({ theme }) => ({
	display: 'flex',
	flexDirection: 'column',
	gap: '8px',
	[theme.breakpoints.down('sm')]: {
		gap: '6px',
	},
	[theme.breakpoints.down('xs')]: {
		gap: '4px',
	},
}));

export const BuyButton = styled(Button)(({ theme }) => ({
	borderColor: '#FFFFFF59',
	backgroundColor: '#FFFFFF1A',
	borderRadius: '40px',
	padding: '8px 16px',
	fontSize: '0.9em',
	[theme.breakpoints.down('sm')]: {
		padding: '4px 8px',
		fontSize: '0.7em',
	},
	[theme.breakpoints.down('xs')]: {
		padding: '3px 6px',
		fontSize: '0.65em',
	},
}));

export const PaymentButtonContainer = styled(Box)(({ theme }) => ({
	...selectedContainerStyles,
	display: 'flex',
	alignItems: 'center',
	gap: '6px',
	padding: '4px 8px',
	borderRadius: '40px',
	[theme.breakpoints.down('sm')]: {
		padding: '3px 6px',
		gap: '4px',
	},
	[theme.breakpoints.down('xs')]: {
		padding: '2px 4px',
		gap: '3px',
	},
}));

export const PaymentText = styled(Typography)(({ theme }) => ({
	color: '#FFFFFF',
	fontSize: '0.9em',
	[theme.breakpoints.down('sm')]: {
		fontSize: '0.8em',
	},
	[theme.breakpoints.down('xs')]: {
		fontSize: '0.75em',
	},
}));

export const ProfileInfoText = styled(Typography)(({ theme }) => ({
	textAlign: 'center',
	color: '#FFFFFF',
	fontSize: '0.8em',
	[theme.breakpoints.down('sm')]: {
		fontSize: '0.7em',
	},
	[theme.breakpoints.down('xs')]: {
		fontSize: '0.65em',
	},
}));

export const SidebarItemsList = styled(Box)(({ theme }) => ({
	display: 'flex',
	flexDirection: 'column',
	alignItems: 'center',
	gap: '4px',
	[theme.breakpoints.down('sm')]: {
		gap: '2px',
	},
}));

export const SidebarItemContainer = styled(Box)<{ selected: boolean; disabled?: boolean }>(
	({ selected, disabled = false, theme }) => ({
		boxSizing: 'border-box',
		display: 'flex',
		flexDirection: 'column',
		alignItems: 'center',
		justifyContent: 'center',
		width: '80%',
		gap: '4px',
		padding: '8px 4px',
		borderRadius: '8px',
		cursor: disabled ? 'default' : 'pointer',
		color: '#FFFFFF',

		...(selected ? selectedContainerStyles : {}),

		[theme.breakpoints.down('sm')]: {
			padding: '4px 2px',
			gap: '2px',
			width: '90%',
		},
		[theme.breakpoints.down('xs')]: {
			padding: '3px 2px',
			gap: '2px',
		},
	})
);

export const SidebarItemText = styled(Typography)(({ theme }) => ({
	color: '#FFFFFF',
	fontSize: '0.8em',
	letterSpacing: '0.4px',
	[theme.breakpoints.down('sm')]: {
		fontSize: '0.7em',
		letterSpacing: '0.2px',
	},
	[theme.breakpoints.down('xs')]: {
		fontSize: '0.65em',
	},
}));
